import React from 'react'
import { IconButton, Tooltip } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

import { originalIcons } from '@shared/components/icons/icons'
import { User } from '@shared/types'

type Props = {
  isNotYetLoggedIn: User['isNotYetLoggedIn']
}

export const AdminGenericDidUserLoggedIn = ({ isNotYetLoggedIn }: Props) => {
  return (
    <Tooltip
      title={
        isNotYetLoggedIn ? 'Uzytkownik nie logował się' : 'Użytkownik aktywny'
      }
    >
      <IconButton
        color="inherit"
        size="large"
      >
        {isNotYetLoggedIn ? (
          <originalIcons.PersonOff />
        ) : (
          <originalIcons.HowToReg />
        )}
      </IconButton>
    </Tooltip>
  )
}

export const useStyles = makeStyles((theme) => ({}))
